import { antPrefixCls } from "utils/antPrefixclsConfig";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { List, Col, Checkbox } from "antd";
import { callApi } from "utils";
const prefixClx = "select-modal-variables";
const Item = List.Item;

class SelectVariable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataSource: [],
    };
  }

  componentDidMount() {
    this.initList();
  } //封装已选择列表

  getSelectObj = (selects = []) => {
    const { dataSource } = this.state;
    const flowUserSelectionType =
      dataSource[0]?.flowUserSelectionType || "variable";
    const obj = {};
    selects
      .filter((val) => val.flowUserSelectionType === flowUserSelectionType)
      .forEach((val) => {
        obj[`${Number(val.sourceIdA)}-${Number(val.sourceIdB)}`] ||
          (obj[`${Number(val.sourceIdA)}-${Number(val.sourceIdB)}`] = true);
      });
    return obj;
  }; //封装不可选择列表

  getDisabledObj = (disabledList = []) => {
    const { dataSource } = this.state;
    const flowUserSelectionType =
      dataSource[0]?.flowUserSelectionType || "variable";
    const obj = {};
    disabledList
      .filter((val) => val.flowUserSelectionType === flowUserSelectionType)
      .forEach((val) => {
        obj[Number(val.sourceIdA)] || (obj[Number(val.sourceIdA)] = true);
      });
    return obj;
  };
  /**
   * 获取列表
   */

  initList = () => {
    // locationType: 工作流场景，personal_center - 园区服务、task_management - 内部办公
    const {
      flowVariableType = "flow",
      locationType = "personal_center",
      nodeType,
      dataSource = [],
      appId,
      nodeId,
      customNo
    } = this.props; //若传入数据源则以传入为主

    if (dataSource.length > 0) {
      return this.setState({
        dataSource,
        loading: false,
      });
    }

    this.setState({
      loading: true,
    });
    const api = "/admin/flow/listVariables";
    const data = {
      pageSize: 10000,
      flowVariableType,
      appId: appId || window.$$context.appId,
      entityType: nodeType,
      entityId: nodeId,
    }; //TODO
    //定义前置节点分割内容

    let dirverObj = [];
    callApi({
      api,
      data,
      success: (res) => {
        // showType：使用场景，0 - 隐藏、1 - 内部办公、2 - 园区服务、3 - 都可见
        // nodeWhiteList：可用的节点类型白名单，有值时，需要进行过滤
        //TODO
        let { flowVars = [], dynamicVars = [] } = res,
          dirverObj = [];
        if (dynamicVars.length > 0)
          dirverObj = [
            {
              label: "前置节点",
              notAllowSelect: true,
            },
          ];
        let allVars = [...flowVars, ...dirverObj, ...dynamicVars];
        allVars = allVars.filter((item) => {
          const { showType = 3, nodeWhiteList = [] } = item;
          if (
            nodeWhiteList.length &&
            nodeType &&
            !nodeWhiteList.includes(nodeType)
          )
            return false;

          if (locationType === "personal_center") {
            return showType === 2 || showType === 3;
          }

          return showType === 1 || showType === 3;
        });
        this.setState({
          loading: false,
          dataSource: allVars,
        });
      },
    });
  }; // 点击列表数据 添加一条数据

  onItemClick = (item) => {
    const { needAllData, selects } = this.props;
    const selectObj = this.getSelectObj(selects);
    const sourceIdA = item.sourceIdA || item.id;
    const sourceIdB = item.sourceIdB || item.idB;
    const itemData = {
      selectionName: item.selectionName || item.label || item.name,
      flowUserSelectionType: item.flowUserSelectionType || "variable",
      sourceIdA,
      sourceIdB,
      sourceTypeA: item.sourceTypeA || "source_variable",
      sourceTypeB: item.sourceTypeB || "node_level",
      sourceDataA: needAllData ? item : undefined,
    };

    if (selectObj[`${sourceIdA}-${sourceIdB}`]) {
      this.props.removeItems([itemData]);
    } else {
      this.props.addItems([itemData]);
    }
  };

  render() {
    const { selects, disabledSelects } = this.props;
    const { loading, dataSource } = this.state;
    const selectObj = this.getSelectObj(selects);
    const disabledObj = this.getDisabledObj(disabledSelects);
    return (
      <Col className="tree-box scroll-tree-box">
        <div
          className={"select-scroll-view"}
          style={{
            marginTop: 16,
          }}
        >
          <List
            dataSource={dataSource}
            size={"small"}
            split={false}
            loading={loading}
            renderItem={(item) => {
              const sourceIdA = item.sourceIdA || item.id;
              const sourceIdB = item.sourceIdB || item.idB;
              const selectionName =
                item.selectionName || item.label || item.name;
              const sourceTypeA = item.sourceTypeA || "source_variable";
              const notAllowSelect = item.notAllowSelect || false;
              let className = "tree-list-item";

              if (
                disabledObj[sourceIdA] &&
                selectObj[`${sourceIdA}-${sourceIdB}`]
              ) {
                className += ` ${antPrefixCls.get()}-tree-node-selected disabled-click`;
              } else if (disabledObj[sourceIdA]) {
                className += " disabled-click";
              } else if (selectObj[`${sourceIdA}-${sourceIdB}`]) {
                className += ` ${antPrefixCls.get()}-tree-node-selected`;
              }

              const selected = (() => {
                if (disabledObj[sourceIdA]) {
                  return false;
                }

                return selects.some(
                  (selectNode) =>
                    selectNode.sourceIdA === sourceIdA &&
                    selectNode.sourceTypeA === sourceTypeA &&
                    selectNode.sourceIdB === sourceIdB
                );
              })();

              return (
                <Item
                  className={className}
                  onClick={() => {
                    !notAllowSelect && !disabledObj[sourceIdA] && this.onItemClick(item);
                  }}
                >
                  <div className={`${prefixClx}-node`}>
                    <div
                      className={`${prefixClx}-node-name`}
                      style={
                        notAllowSelect
                          ? {
                              color: "rgb(193,193,193)",
                            }
                          : null
                      }
                    >
                      {selectionName}
                    </div>
                    {!notAllowSelect && (
                      <span className={`${prefixClx}-node-handle`}>
                        <Checkbox
                          disabled={disabledObj[sourceIdA]}
                          checked={selected}
                        />
                      </span>
                    )}
                  </div>
                </Item>
              );
            }}
          />
        </div>
      </Col>
    );
  }
}

SelectVariable.propTypes = {
  // 组织架构数据
  organizations: PropTypes.object.isRequired,
  organizationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /* 以下是configs额外传进来的参数 */
  // 扩展的树节点，格式为 [{id: -1, name: '不限部门', type: 'source_unlimited_department', childrens: [...]}]
  extendTree: PropTypes.array,
  disabledSelects: PropTypes.array,
  selects: PropTypes.array,
  addItems: PropTypes.func.isRequired,
  removeItems: PropTypes.func.isRequired,
  appId: PropTypes.number,
};
export default SelectVariable;
